'use client'
import React, { useState, useEffect } from "react";
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";
import { Fade} from "react-reveal"
import logo from "../../images/swerl_logo.png"
import {
  Nav,
  NavContainer,
  NavLink,
  NavLogo,
  Bars,
  NavMenu,
  NavBtn,
  NavBtnLink,
  Img,
  NavImg,
  NavLinkA,
  SearchBtn,
  CloseIcon,
  SearchContainer,
  NotificationButton,
  MusicUploadsButton,
  NFTokenCollectionButton,
  PlaylistBtn,
} from "./NavbarElements";
import { ThemeProvider } from "styled-components";
import { useWebsiteTheme } from "../WebsiteTheme/WebsiteThemeContext";
//import logo from "../../images/swerllogo.png" 
//import { getObjectLength } from "../../utils";


const Navbar = ({toggleN, toggle, navInfo }) => {
  const {themeColors} = useWebsiteTheme()
  const [scrollNav, setScrollNav] = useState(false);
  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
  }, []);


  const toggleHome = () => {
    scroll.scrollToTop();
  };

 /*  const toggleNotifications = () => {
    let isToggled = notificationToggle
    setNotificationToggle(!isToggled)
  } */


  return (
    <>
   
        <IconContext.Provider
          value={{ color: scrollNav ? themeColors.mainBg : themeColors.secondaryBg }}
        >
        <Nav scrollNav={scrollNav}>
            <NavContainer>
              <NavLogo
                onClick={toggleHome}
                to={"/"}
              >
                <NavImg  src={logo} alt='Swərl' style={{width: "8rem"}} />
              </NavLogo>

              <NavMenu>
              
                {navInfo.links &&
                  navInfo.links.map((link) => {
                   if(!link.file){
                      return (
                        <NavLink
                          scrollNav={scrollNav}
                          key={link.id}
                          id={link.id}
                          to={link.to}
                        >
                          {link.title}
                        </NavLink>
                      );}
                    
                  })}
              </NavMenu>
            </NavContainer>
          </Nav>
        </IconContext.Provider>
    </>
  );
};

export default Navbar;
